import { render } from "./GroupContentComponent.vue?vue&type=template&id=2a7e71b9&scoped=true"
import script from "./GroupContentComponent.vue?vue&type=script&lang=js"
export * from "./GroupContentComponent.vue?vue&type=script&lang=js"

import "./GroupContentComponent.vue?vue&type=style&index=0&id=2a7e71b9&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a7e71b9"]])

export default __exports__